import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { CRUISE_URL } from './constant/BaseApiUrl';

export default class CruiseService {
  getCruiseInfo() {
    return axios.get(`${CRUISE_URL}${ApiKey.GET_NEW_CRUISES}`);
  }
  getVendors(payload, desId) {
    return axios.post(`${CRUISE_URL}${ApiKey.GET_CRUISE_VENDOR}?destId=${desId}`, payload);
  }
  getShips(payload) {
    return axios.post(`${CRUISE_URL}${ApiKey.GET_CRUISE_SHIPS}`, payload);
  }

  getCruiseSailing(destinationId, vendorId, shipId) {
    return axios.get(`${CRUISE_URL}${ApiKey.GET_CRUISE_SAILING}?destId=${destinationId}&vendorId=${vendorId}&shipId=${shipId}`);
  }
  syncData() {
    return axios.get(`${CRUISE_URL}${ApiKey.SYNC_DATA}`);
  }

  getRetPortId(id) {
    return axios.get(`${CRUISE_URL}${ApiKey.DEPARTURE_PORT}/${id}`);
  }

  getNewVendor(payload) {
    return axios.post(`${CRUISE_URL}${ApiKey.GET_CRUISE_VENDOR}/list-by-destinations`, payload);
  }

  getNewSailing(destinationId, vendorId, shipId) {
    return axios.post(`${CRUISE_URL}${ApiKey.GET_CRUISE_SAILING}/list-by-destinations?shipId=${shipId}&&vendorId=${vendorId}`, destinationId);
  }
}
